import { initializeApp } from 'firebase/app';
import {
  initializeAuth, browserLocalPersistence, indexedDBLocalPersistence, browserPopupRedirectResolver,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC5gE3q47v4iO1kP9cKYYICz299hRbJLnI",
  authDomain: "admin-portal-d.firebaseapp.com",
  projectId: "admin-portal-d",
  storageBucket: "admin-portal-d.firebasestorage.app",
  messagingSenderId: "135532072911",
  appId: "1:135532072911:web:020cfec9ef900a2e4cccba",
  measurementId: "G-C7413F7EDV"
};

export { firebaseConfig };
export const app = initializeApp(firebaseConfig);
// getAuth() would give the SDK default chain, which tries IndexedDB first and only falls back to
// localStorage. That order is deliberately reversed here.
//
// The symptom it addresses: an installed PWA cold-starts, authStateReady() settles with nobody
// signed in, and a single refresh then finds the session. The data is on disk the whole time -- it
// is the first read that comes back empty. IndexedDB is asynchronous and, in a freshly launched
// standalone window, is the part of that pair that can be slow or briefly unavailable; localStorage
// is synchronous and is there from the first tick.
//
// Auth tokens are small and short-lived, so localStorage is a perfectly adequate home for them;
// IndexedDB stays in the list as the fallback rather than being removed.
//
// popupRedirectResolver has to be passed explicitly: initializeAuth does not install one, and the
// staff login uses signInWithPopup for Google.
export const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence, indexedDBLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});
export const db = getFirestore(app);
export const storage = getStorage(app);
